export interface MembershipWarningContext {
  resolvedMembershipId: string | null
  targetForestOwnerMembershipId: string | null | undefined
  membershipExists: boolean
  hasDisplayContext: boolean
}

// Pure domain rules for the cooperative membership warning shown when adding/transferring a property. Unit-tested.
export function shouldShowCooperativeMembershipWarning(ctx: MembershipWarningContext): boolean {
  if (!ctx.resolvedMembershipId || !ctx.membershipExists || !ctx.hasDisplayContext) {
    return false
  }

  if (!ctx.targetForestOwnerMembershipId) {
    return true
  }

  return ctx.resolvedMembershipId !== ctx.targetForestOwnerMembershipId
}

const DOCUMENTABLE_OWNERSHIP_TYPES = new Set(['Eierskap', 'Eksklusiv bruksrett'])

export function isDocumentableCooperativeWarningOwnershipType(documentType: string): boolean {
  return DOCUMENTABLE_OWNERSHIP_TYPES.has(documentType)
}
